import { useMemo } from 'react';
import { useFabricsContext } from '../providers/FabricsProvider';
export const buildDataAttributes = (data, init) => data ? Object.keys(data).reduce((c, k) => ({ ...c, [`data-${k}`]: data[k] }), init) : init;
export const useDataAttributes = (dataAttributes, dataTest) => {
    const { env } = useFabricsContext();
    return useMemo(() => buildDataAttributes(dataAttributes, env !== 'production' && dataTest ? { 'data-test': dataTest } : {}), [dataAttributes, env, dataTest]);
};
